var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BCSwitch',{attrs:{"disabled":_vm.isLoading},model:{value:(_vm.isEnabled),callback:function ($$v) {_vm.isEnabled=$$v},expression:"isEnabled"}},[_vm._v(" "+_vm._s(_vm.$t('video_chat.bar_header.remember_me'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }